import { resolveObjectURL } from 'buffer';

export default {
  /**
   * Filter list of welcome items which have a anzeige_von <= currentDayTime < anzeige_bis (or anzeige_bis=null)
   * Items with older anzeige_von precede.
   * @param {*} dateAsMsFromEpoch the number of milliseconds since the a date and midnight, January 1, 1970.
   * @param {*} welcomeItems all welcome items
   * @returns valid welcome items for the appointed date
   */
  getCurrentWelcomeItems(dateAsMsFromEpoch, welcomeItems = [], syncAfterAuthentication) {
    return welcomeItems
      .filter((w) => {
        // if (syncAfterAuthentication) {
        if (w.doNotShowAgain && w.read) return false;
        // } else {
        //   if (w.read) return false;
        // }
        if (w.read === true) return false;
        let fromTime = w.anzeige_von ? Date.parse(w.anzeige_von) : null;
        let toTime = w.anzeige_bis ? Date.parse(w.anzeige_bis) : null;
        return fromTime <= dateAsMsFromEpoch && (toTime === null || toTime > dateAsMsFromEpoch);
      })
      .sort((w1, w2) => {
        return Date.parse(w1.anzeige_von) - Date.parse(w2.anzeige_von);
      });
  },
  /**
   * Synchronize welcomeItems with information stored in local storage (mainly read state)
   * @param {*} welcomeItems
   */
  synchronizeWithLocalStorage(welcomeItems) {
    let welcomeItemsById = JSON.parse(localStorage.getItem('welcomeItemsById')) || {};
    welcomeItems.forEach((w) => {
      const itemState = welcomeItemsById[w.id];
      if (itemState) {
        w.read = itemState.read;
        w.doNotShowAgain = itemState.doNotShowAgain;
      }
    });
  },
  /**
   * Stores the welcome items, resp. read state information to the local storage to enable offline capability.
   * @param {*} welcomeItems
   */
  updateLocalStorage(welcomeItems) {
    const welcomeItemsById = {};
    welcomeItems.forEach((w) => {
      welcomeItemsById[w.id] = { read: w.read, doNotShowAgain: w.doNotShowAgain };
    });
    // Update localStorage
    localStorage.setItem('welcomeItemsById', JSON.stringify(welcomeItemsById));
  },
};
